export default __webpack_public_path__ + "static/media/appsIconHCSelected.bbd844d6.svg";